import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Button } from '@daedalus/atlas/Button';
import { Divider } from '@daedalus/atlas/Divider';
import { Box } from '@daedalus/atlas/helpers/Box';
import { TitleBar } from '@daedalus/atlas/helpers/TitleBar';
import { Icon } from '@daedalus/atlas/Icon';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { getError } from '../../modules/selector';
import { BookingCreation } from '../BookingCreation';
import { ErrorAlert } from '../ErrorMessage/ErrorAlert';
import { FreezeOverlay } from '../FreezeOverlay';
import { SimplifiedHotelCard } from '../SimplifiedHotelCard';
import { FreezeCTA } from './FreezeCTA';
import { FreezeDetailsHeader } from './FreezeDetailsHeader';
import { OfferCheck } from './OfferCheck';
import { HotelCardSkeleton } from './SkeletonLoading';
const ScrollableWrapper = /*#__PURE__*/styled('div')({
  name: "ScrollableWrapper",
  class: "s1pptvr5",
  propsAsIs: false
});
const CtaWrapper = /*#__PURE__*/styled('div')({
  name: "CtaWrapper",
  class: "c1hh7lm5",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => Button;
const CloseButton = /*#__PURE__*/styled(_exp3())({
  name: "CloseButton",
  class: "cqihef0",
  propsAsIs: true
});
interface Props {
  offerLink: string | undefined;
  isOpen: boolean;
  isPageLoading: boolean;
  isCreateBookingLoading: boolean;
  hideOverlay: () => void;
  handleCreateFreezeBooking: () => void;
}
export const FreezeDetailsDesktop: React.FC<Props> = ({
  isOpen,
  offerLink,
  isCreateBookingLoading,
  isPageLoading,
  hideOverlay,
  handleCreateFreezeBooking
}) => {
  const {
    errored
  } = useSelector(getError);
  const Content = useMemo(() => {
    if (isPageLoading) {
      return <ScrollableWrapper>
          <Box paddingRight="s700" paddingLeft="s700" paddingTop="s500">
            <HotelCardSkeleton />
          </Box>
        </ScrollableWrapper>;
    }
    if (isCreateBookingLoading) {
      return <ScrollableWrapper>
          <BookingCreation />
        </ScrollableWrapper>;
    }
    return <ScrollableWrapper>
        <Box paddingRight="s700" paddingLeft="s700" paddingTop="s500">
          <Box display="flex" flexDirection="column" gap="s400">
            <ErrorAlert />
            <SimplifiedHotelCard />
          </Box>
        </Box>
      </ScrollableWrapper>;
  }, [isCreateBookingLoading, isPageLoading]);
  return <FreezeOverlay isOpen={isOpen} onClose={hideOverlay}>
      <TitleBar endContent={<CloseButton variant="quiet" iconStart={<Icon size="md" name={'Close'} />} onClick={hideOverlay} />} />
      <Divider />
      {!isCreateBookingLoading && <Box paddingTop="s600" paddingRight="s700" paddingLeft="s700">
          <FreezeDetailsHeader isLoading={isPageLoading} alignment="left" />
        </Box>}
      {offerLink && <OfferCheck offerLink={offerLink} />}
      {Content}

      {!isCreateBookingLoading && !errored && <CtaWrapper>
          <Divider />
          <Box paddingLeft="s700" paddingRight="s700" paddingTop="s500" paddingBottom="s700">
            <FreezeCTA isPageLoading={isPageLoading} handleCreateFreezeBooking={handleCreateFreezeBooking} ctaTitleText={<FormattedMessageWrapper id="df.oneClickToFreeze" defaultMessage="One click to freeze – zero obligation to book." />} />
          </Box>
        </CtaWrapper>}
    </FreezeOverlay>;
};

require("./FreezeDetailsDesktop.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FreezeDetailsDesktop.tsx");